export default function Dominio() {
    return (<span>DOMINIO</span>)
}
